import React, { Component } from "react";
import { connect } from 'react-redux';
import AutoSizer from "react-virtualized-auto-sizer";
import { Rnd } from "react-rnd";
import AttendeesListFanout from './AttendeesListFanout';
import AttendeesChatFanout from './AttendeesChatFanout';
import FloatingEmoji from '../FloatingEmoji';
import * as chatActions from "../../../actions/chat_actions";

class ResizableRosterFanout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            runningAnimation: false,
            attendeesListOpened: props.attendeesListOpened,
            show: 'chat',
            width: null,
            height: null,
            rndWidth: 350,
            rndHeight: 400,
            rndX: 0,
            rndY: 0,
            side: 'mount'
        };

        this.handleResize = this.handleResize.bind(this);
        this.dragStop = this.dragStop.bind(this);
        this.rndResize = this.rndResize.bind(this);
    }

    getChatPosition() {
        const { width, height } = this.state;

        let chatPosition = window.localStorage.getItem('chatPosition');

        if (chatPosition) {
            try {
                chatPosition = JSON.parse(chatPosition);

                let storageX, storageY, storageWidth, storageHeight;

                storageWidth = chatPosition.side ? 350 : chatPosition.rndWidth === 100 ? '100%' : parseInt(chatPosition.rndWidth * (width / 100)) || 0;
                storageHeight = chatPosition.side || chatPosition.rndHeight === 100 ? '100%' : parseInt(chatPosition.rndHeight * (height / 100)) || 0;
                storageY = parseInt(chatPosition.rndY * (height / 100)) || 0;
                storageX = chatPosition.side && chatPosition.side === 'left' ? 0 : chatPosition.side && chatPosition.side === 'right' ? width - storageWidth : parseInt(chatPosition.rndX * (width / 100)) || 0;

                this.setState({
                    rndX: storageX,
                    rndY: storageY,
                    rndHeight: storageHeight,
                    rndWidth: storageWidth,
                    side: chatPosition.side || ''
                });
            } catch (e) {
                console.error(e);
            }
        } else {
            this.setState({
                rndX: width / 4,
                rndY: height - 285,
                rndHeight: 200,
                rndWidth: width / 2,
                side: ''
            });
        }
    }

    saveChatPosition() {
        const { rndX, rndY, rndHeight, rndWidth, width, height, side } = this.state;

        if (!side || side && side !== 'mount') {
            const position = {
                rndX: parseFloat(rndX / (width / 100)).toFixed(2) || 0,
                rndY: parseFloat(rndY / (height / 100)).toFixed(2) || 0,
                rndHeight: rndHeight === '100%' ? '100.00' : parseFloat(rndHeight / (height / 100)).toFixed(2) || 0,
                rndWidth: rndWidth === '100%' ? '100.00' : parseFloat(rndWidth / (width / 100)).toFixed(2) || 0,
                side: side || ''
            }
            window.localStorage.setItem('chatPosition', JSON.stringify(position));
        }
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        const { side, width, show } = this.state;
        const { attendeesListOpened, messages, newMessage, resetBadgeMessage, newBadgeMessage  } = this.props;
        // Check if it should stop animation
        if (prevProps.attendeesListOpened == true && attendeesListOpened == false) {
            setTimeout(() => {
                this.setState({ runningAnimation: false });
            }, 250);
        }

        if (prevState.width !== width && width <= 1200 && width < prevState.width) {
            this.setState({
                rndX: 0,
                rndY: 0,
                rndHeight: '100%',
                rndWidth: 350
            },() => {
                this.saveChatPosition();
            });
        }

        if (prevProps.attendeesListOpened !== attendeesListOpened) {
            this.handleSetRosterId(window.innerWidth);

            if (attendeesListOpened) {
                const { width, height, side } = this.state;

                if (width && height && side && side === 'mount') {
                    this.getChatPosition();
                }
            } else if (side) {
                this.setState({
                    side: ''
                },() => {
                    this.saveChatPosition();
                });
            }
        }

        if (messages && messages.length && prevProps.messages && prevProps.messages.length !== messages.length && prevProps.messages.length < messages.length && !newMessage && newBadgeMessage && ((!attendeesListOpened) || (attendeesListOpened && show && show !== 'chat' && width && width <= 1200))) {
            newBadgeMessage();
        }
        if (((((attendeesListOpened && width && width > 1200) || (attendeesListOpened && show && show === 'chat' && width && width <= 1200)) && attendeesListOpened !== prevProps.attendeesListOpened) || (show && show === 'chat' && show !== prevState.show)) && newMessage && resetBadgeMessage) {
            resetBadgeMessage();
        }
    }

    handleSetRosterId(width) {
        const { show } = this.state;
        const { setRosterState, attendeesListOpened } = this.props;
        if (attendeesListOpened && width > 1200 && show && show === 'chat' && setRosterState) {
            setRosterState(true);
        } else if (setRosterState) {
            setRosterState(false);
        }
    }

    handleResize(event) {
        const { rndX, rndY, rndHeight, rndWidth, width, height, side } = this.state;

        this.setState({
            width: event.width,
            height: event.height
        });

        if (this.props.attendeesListOpened && event.width) {
            this.handleSetRosterId(event.width);

            const position = {
                rndX: parseFloat(rndX / (width / 100)) || 0,
                rndY: parseFloat(rndY / (height / 100)) || 0,
                rndHeight: rndHeight === '100%' ? 100 : parseFloat(rndHeight / (height / 100)) || 0,
                rndWidth: rndWidth === '100%' ? 100 : parseFloat(rndWidth / (width / 100)) || 0,
                side: side || ''
            }

            this.setState({
                rndX: parseFloat(position.rndX * (event.width / 100)) || 0,
                rndY: parseFloat(position.rndY * (event.height / 100)) || 0,
                rndHeight: rndHeight === '100%' ? rndHeight : parseFloat(position.rndHeight * (event.height / 100)) || 0,
                rndWidth: rndWidth === '100%' ? rndWidth : parseFloat(position.rndWidth * (event.width / 100)) || 0,
                side: position.side || ''
            }, () => {
                this.handleSetSide();
                this.saveChatPosition();
            });
        }
    }

    setShowState(value, width) {
        const { side, rndX, rndWidth } = this.state;

        let val = width > 1200 ? value === 'list' && this.state.show === 'list' ? 'chat' : 'list' : value;
        this.setState({
            show: val
        }, () => {
            this.handleSetRosterId(width);
            if (val === 'list' && ((side && side === 'right') || (((rndX + rndWidth) < width + 20) && ((rndX + rndWidth) > width - 370)))) {
                this.setState({
                    rndX: width - 700,
                    side: 'right',
                    rndY: 0,
                    rndHeight: '100%',
                    rndWidth: 350
                }, () => {
                    this.saveChatPosition();
                });
            } else if (val === 'chat' && side && side === 'right') {
                this.setState({
                    rndX: width - 350,
                    rndY: 0,
                    rndHeight: '100%',
                    rndWidth: 350
                },() => {
                    this.saveChatPosition();
                });
            }
        });
    }

    dragStop(e, d) {
        this.setState({
            rndX: d.x, rndY: d.y
        }, () => {
            this.handleSetSide();
            this.saveChatPosition();
        });
    }

    handleSetSide() {
        const { rndWidth, rndX, width, side, show } = this.state;
        if (rndX === 0 || rndX < 20) {
            this.setState({
                rndY: 0,
                rndX: 0,
                rndHeight: '100%',
                rndWidth: 350,
                side: 'left'
            },() => {
                this.saveChatPosition();
            });
        } else if (((rndX + rndWidth) === width) || (((rndX + rndWidth) < width + 20) && ((rndX + rndWidth) > width - 20))) {
            this.setState({
                rndY: 0,
                rndX: width - 350,
                rndHeight: '100%',
                rndWidth: 350,
                side: 'right'
            },() => {
                this.saveChatPosition();
            });
        } else if (((rndX + rndWidth) < width + 10) && ((rndX + rndWidth) > width - 370) && show && show === 'list') {
            this.setState({
                rndY: 0,
                rndX: width - 700,
                rndHeight: '100%',
                rndWidth: 350,
                side: 'right'
            },() => {
                this.saveChatPosition();
            });
        } else if (side) {
            this.setState({
                side: ''
            },() => {
                this.saveChatPosition();
            });
        }
    }

    rndResize(e, direction, ref, delta, position) {
        this.setState({
            rndWidth: ref.offsetWidth,
            rndHeight: ref.offsetHeight,
            rndX: position.x,
            rndY: position.y
        }, () => {
            const { hideEmoji } = this.props;
            
            if(hideEmoji) {
                hideEmoji();
            }

            this.saveChatPosition();
        });
    }

    render() {
        const { show, rndHeight, rndWidth, rndX, rndY } = this.state;
        const { attendeesListOpened, sendMessage, mode, showEmoji, emoji } = this.props;

        return (
            <AutoSizer onResize={this.handleResize}>
                {({ height, width }) => {
                    if (width && width > 1200) {
                        return (
                            <div className='resizable-wrapper'>
                                <div
                                    className={
                                        show && show === 'list'
                                            ? this.state.runningAnimation
                                                ? "attendees-list attendees-list-out"
                                                : attendeesListOpened
                                                    ? "attendees-list"
                                                    : "attendees-list-hidden"
                                            : "attendees-list-hidden"
                                    }
                                >
                                    <AttendeesListFanout
                                        roster={width < 1200}
                                        showState={show}
                                        setShowState={(value) => this.setShowState(value, width)}
                                    />
                                </div>
                                <Rnd
                                    className={`${
                                        this.state.runningAnimation
                                            ? "attendees-chat attendees-chat-out"
                                            : attendeesListOpened
                                                ? 'attendees-chat'
                                                : "attendees-chat-hidden"
                                        } draggable-chat`}
                                    bounds={mode && mode === 'tiles' ?
                                        '.SidebarTiles' :
                                        mode && mode === 'speaker' ?
                                            '.SidebarSpeaker' :
                                            'body'}
                                    cancel='.container-input-chat'
                                    size={{ width: rndWidth, height: rndHeight }}
                                    position={{ x: rndX, y: rndY }}
                                    onDragStop={this.dragStop}
                                    onResize={this.rndResize}
                                    minWidth={350}
                                    minHeight={200}
                                >
                                    <AttendeesChatFanout
                                        attendeesChatOpened={attendeesListOpened}
                                        sendMessage={sendMessage}
                                        roster={true}
                                        showState={show}
                                        width={width}
                                        setShowState={(value) => this.setShowState(value, width)}
                                        draggable={true}
                                    />
                                </Rnd>
                                {showEmoji ?
                                    <FloatingEmoji
                                        emoji={emoji}
                                    />
                                    : null}
                            </div>
                        )
                    } else {
                        return (
                            <div>
                                {show === 'chat' ? <div
                                    className={
                                        this.state.runningAnimation
                                            ? "attendees-chat attendees-chat-out"
                                            : attendeesListOpened
                                                ? `attendees-chat ${width < 1200 ? 'resizable-roster-chat-hidden' : 'resizable-roster-chat'}`
                                                : "attendees-chat-hidden"
                                    }
                                >
                                    <AttendeesChatFanout
                                        attendeesChatOpened={attendeesListOpened}
                                        sendMessage={sendMessage}
                                        roster={true}
                                        showState={show}
                                        width={width}
                                        setShowState={(value) => this.setShowState(value, width)}
                                    />
                                </div>
                                    :
                                    <div
                                        className={
                                            this.state.runningAnimation
                                                ? "attendees-list attendees-list-out"
                                                : attendeesListOpened
                                                    ? `attendees-list ${width < 1200 ? 'resizable-roster-list-hidden' : 'resizable-roster-list'}`
                                                    : "attendees-list-hidden"
                                        }
                                    >
                                        <AttendeesListFanout
                                            roster={width < 1200}
                                            showState={show}
                                            setShowState={(value) => this.setShowState(value, width)}
                                        />
                                    </div>
                                }
                                {showEmoji ?
                                    <FloatingEmoji
                                        emoji={emoji}
                                    />
                                    : null}
                            </div>
                        )
                    }
                }}
            </AutoSizer>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        messages: state.chat.messages,
        newMessage: state.chat.newMessage,
        showEmoji: state.chat.showEmoji,
        emoji: state.chat.emoji
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        newBadgeMessage: () => {
            dispatch(chatActions.newBadgeMessage());
        },
        resetBadgeMessage: () => {
            dispatch(chatActions.resetBadgeMessage());
        },
        hideEmoji: () => {
            dispatch(chatActions.hideEmojiForm());
        }
    };
};

const ResizableRosterFanoutContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ResizableRosterFanout);

export default ResizableRosterFanoutContainer;